(function () {
  'use strict';

  var configEl = document.getElementById('lux-judgeme-config');
  if (!configEl) return;

  var config = {};
  try {
    config = JSON.parse(configEl.textContent || '{}');
  } catch (e) {
    return;
  }

  var API_BASE = config.apiBase || 'https://api.judge.me/api/v1';

  function hasToken() {
    return Boolean(config.publicToken);
  }

  function apiUrl(path, params) {
    var url = new URL(API_BASE + path);
    url.searchParams.set('shop_domain', config.shopDomain);
    if (hasToken()) {
      url.searchParams.set('api_token', config.publicToken);
    }
    if (params) {
      Object.keys(params).forEach(function (key) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          url.searchParams.set(key, String(params[key]));
        }
      });
    }
    return url.toString();
  }

  function apiFetch(path, options, params) {
    var headers = Object.assign({}, (options && options.headers) || {});
    if (hasToken()) {
      headers['X-Api-Token'] = config.publicToken;
    }
    return fetch(apiUrl(path, params), Object.assign({}, options || {}, { headers: headers }));
  }

  function extractHtml(response, text) {
    var trimmed = (text || '').trim();
    if (!trimmed) return '';
    if (trimmed.charAt(0) === '{') {
      try {
        var json = JSON.parse(trimmed);
        return json.widget || json.html || json.product_review_widget || '';
      } catch (err) {
        return '';
      }
    }
    return trimmed;
  }

  function loadWidgetHtml(target) {
    if (!target || !hasToken()) return Promise.resolve(false);

    var existing = target.innerHTML.replace(/<!--[\s\S]*?-->/g, '').trim();
    if (existing.length > 20) return Promise.resolve(true);

    target.setAttribute('data-lux-judgeme-loading', '');

    return apiFetch('/widgets/product_review', { method: 'GET' }, {
      external_id: config.productId,
      handle: config.productHandle
    })
      .then(function (res) {
        return res.text().then(function (text) {
          if (!res.ok) throw new Error('widget_failed');
          return extractHtml(res, text);
        });
      })
      .then(function (html) {
        target.removeAttribute('data-lux-judgeme-loading');
        if (!html) return false;
        target.innerHTML = html;
        initJudgeWidgets();
        return true;
      })
      .catch(function () {
        target.removeAttribute('data-lux-judgeme-loading');
        return false;
      });
  }

  function loadBadgeHtml(target) {
    if (!target || !hasToken()) return Promise.resolve(false);

    var existing = target.innerHTML.replace(/<!--[\s\S]*?-->/g, '').trim();
    if (existing.length > 10) return Promise.resolve(true);

    return apiFetch('/widgets/preview_badge', { method: 'GET' }, {
      external_id: config.productId,
      handle: config.productHandle
    })
      .then(function (res) {
        return res.text().then(function (text) {
          if (!res.ok) throw new Error('badge_failed');
          return extractHtml(res, text);
        });
      })
      .then(function (html) {
        if (!html) return false;
        target.innerHTML = html;
        initJudgeWidgets();
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function initJudgeWidgets() {
    if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
      window.jdgm.loadWidgets();
    }
    if (window.jdgm && typeof window.jdgm.init === 'function') {
      window.jdgm.init();
    }
  }

  function openJudgeModal() {
    if (window.jdgm) {
      if (typeof window.jdgm.openWriteReviewModal === 'function') {
        window.jdgm.openWriteReviewModal(config.productId);
        return true;
      }
      if (window.jdgm.writeReviewModal && typeof window.jdgm.writeReviewModal.open === 'function') {
        window.jdgm.writeReviewModal.open(config.productId);
        return true;
      }
      if (window.jdgm.customForms && typeof window.jdgm.customForms.openWriteReviewForm === 'function') {
        window.jdgm.customForms.openWriteReviewForm(config.productId);
        return true;
      }
    }

    var widgetBtn = document.querySelector(
      '#judgeme_product_reviews .jdgm-write-rev-link, ' +
      '#judgeme_product_reviews .jdgm-write-review-modal, ' +
      '.jdgm-write-rev-link'
    );
    if (widgetBtn) {
      widgetBtn.click();
      return true;
    }
    return false;
  }

  function getModal() {
    return document.querySelector('[data-lux-judgeme-modal]');
  }

  function openCustomModal() {
    var modal = getModal();
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('lux-judgeme-modal-open');
    var firstInput = modal.querySelector('input, textarea, button');
    if (firstInput) firstInput.focus();
  }

  function closeCustomModal() {
    var modal = getModal();
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('lux-judgeme-modal-open');
  }

  function setRating(form, rating) {
    form.querySelectorAll('[data-lux-judgeme-star]').forEach(function (btn) {
      var value = Number(btn.getAttribute('data-lux-judgeme-star'));
      btn.classList.toggle('is-active', value <= rating);
      btn.setAttribute('aria-pressed', value <= rating ? 'true' : 'false');
    });
    var input = form.querySelector('[name="rating"]');
    if (input) input.value = String(rating);
  }

  function submitReview(form) {
    var fd = new FormData(form);
    var payload = {
      shop_domain: config.shopDomain,
      platform: config.platform || 'shopify',
      id: Number(config.productId),
      name: String(fd.get('name') || '').trim(),
      email: String(fd.get('email') || '').trim(),
      rating: Number(fd.get('rating') || 0),
      title: String(fd.get('title') || '').trim(),
      body: String(fd.get('body') || '').trim()
    };

    if (!payload.name || !payload.email || !payload.body || payload.rating < 1) {
      return Promise.reject(new Error('validation'));
    }

    return fetch(API_BASE + '/reviews', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.error) {
          throw new Error(data.error || 'submit_failed');
        }
        return data;
      });
    });
  }

  function bindModal() {
    var modal = getModal();
    if (!modal) return;

    modal.querySelectorAll('[data-lux-judgeme-close]').forEach(function (el) {
      el.addEventListener('click', closeCustomModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeCustomModal();
    });

    var form = modal.querySelector('[data-lux-judgeme-form]');
    if (!form) return;

    form.querySelectorAll('[data-lux-judgeme-star]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setRating(form, Number(btn.getAttribute('data-lux-judgeme-star')));
      });
    });

    setRating(form, 5);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var message = form.querySelector('[data-lux-judgeme-message]');
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      if (message) {
        message.textContent = '';
        message.hidden = true;
      }

      submitReview(form)
        .then(function () {
          if (message) {
            message.textContent = config.successMessage;
            message.hidden = false;
            message.classList.remove('is-error');
          }
          form.reset();
          setRating(form, 5);
          var widget = document.querySelector('[data-lux-judgeme-widget]');
          if (widget) loadWidgetHtml(widget);
          window.setTimeout(closeCustomModal, 1800);
        })
        .catch(function () {
          if (message) {
            message.textContent = config.errorMessage;
            message.hidden = false;
            message.classList.add('is-error');
          }
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function bindWriteButtons() {
    document.querySelectorAll('[data-lux-write-review]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();

        if (openJudgeModal()) return;

        var attempts = 0;
        var timer = window.setInterval(function () {
          attempts += 1;
          if (openJudgeModal() || attempts > 12) {
            window.clearInterval(timer);
            if (attempts > 12) openCustomModal();
          }
        }, 250);
      });
    });
  }

  function showEmptyState(target) {
    if (!target || target.querySelector('.lux-judgeme__empty')) return;
    var existing = target.innerHTML.replace(/<!--[\s\S]*?-->/g, '').trim();
    if (existing.length > 20) return;

    target.innerHTML = [
      '<div class="lux-judgeme__empty">',
      '  <p class="lux-judgeme__empty-copy">',
      '    How was your experience?',
      '    <button type="button" class="lux-judgeme__empty-cta" data-lux-write-review>Share it here</button>',
      '  </p>',
      '</div>'
    ].join('');

    var cta = target.querySelector('[data-lux-write-review]');
    if (cta) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        if (!openJudgeModal()) openCustomModal();
      });
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function init() {
    var widget = document.querySelector('[data-lux-judgeme-widget]');
    var badge = document.querySelector('[data-lux-judgeme-badge]');

    bindModal();
    bindWriteButtons();

    Promise.all([
      loadWidgetHtml(widget),
      loadBadgeHtml(badge)
    ]).then(function (results) {
      if (!results[0]) showEmptyState(widget);
    });

    window.setTimeout(initJudgeWidgets, 600);
    window.setTimeout(initJudgeWidgets, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
